<template>
  <div style="display: flex; flex: 1" v-loading="!measurement">
    <div v-if="
      checkPermission('readMeasurement') &&
      measurement &&
      measurement.device &&
      measurement.device.type != 'DUCKV1'
    " style="flex: 1; padding: 20px">
      <el-page-header class="fixedheader" @back="goBack" :title="$t('admin.back')">
        <template slot="content">
          {{ path }}
          <strong style="position: absolute; right: 100px">


            <span>
              <el-badge style="top: -3px;    left: -10px;    position: relative;" :value="compares.length">
                <el-button @click="showCompareBasket" size="mini" >{{ $t("common.compare") }}
                  <em class="fas fa-shopping-basket"></em>
                </el-button>
              </el-badge>
              <el-popover :content="$t('measurement.favoritepopover')" placement="bottom" trigger="hover" width="200">
                <em slot="reference" id="favorite-button" v-loading="favoriteLoading" @click="toggleFavorite()"
                  style="font-size: 26px; color: #ffd500" v-bind:class="favoriteClass"></em>
              </el-popover>

              {{ dateDate(measurement.createdAt) }}
            </span>
          </strong>

          <el-dropdown @command="handleCommand" style="cursor: pointer; position: absolute; right: 50px">
            <span class="el-dropdown-link">
              <em class="el-icon-s-tools" style="font-size: 24px" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="link">
                {{ $t("measurement.generateLink") }}
              </el-dropdown-item>
              <el-dropdown-item command="download">
                {{ $t("measurement.download") }}
              </el-dropdown-item>
              <el-dropdown-item v-if="checkPermission('deleteMeasurement')" command="delete">
                {{ $t("common.delete") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-page-header>
      <br />
      <br />
      <el-row v-if="measurement && measurement.measurementData.length">
        <el-col :span="24">
          <!-- Welcome -->
          <el-card v-loading="!loaded" :shadow="'never'">
            <el-row>
              <el-col :span="4">
                <el-form ref="form" label-position="top" label-width="100px" size="small">
                  <el-form-item :label="$t('measurement.sensor')">
                    <el-select v-on:change="View()" v-model="selectValue" placeholder="Select" class="w-100">
                      <el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-popover placement="bottom" style="margin-left: 10px" width="300" trigger="click">
                      <el-row>
                        <el-col>
                          <el-input type="textarea" :placeholder="$t(`common.takeNote`)" :maxlength="1000"
                            :show-word-limit="true" v-model="note" size="small" />
                        </el-col>
                        <el-col>
                          <el-button style="margin-top: 10px; float: right" size="mini" @click="saveNote()">
                            {{ $t("common.save") }}</el-button>
                        </el-col>
                      </el-row>
                      <el-button icon="el-icon-notebook-2" slot="reference"></el-button>
                    </el-popover>
                  </el-form-item>
                  <el-form-item v-if="measurement">
                    <div v-for="defaultTelemetry in defaultTelemetries" :key="defaultTelemetry.name">
                      <strong>{{
                          defaultTelemetry.telemetry
                      }}</strong>: {{ defaultTelemetry.value.toFixed(4) }}
                      <el-tooltip :content="
                        $t(`telemetry.info.${defaultTelemetry.telemetry}`)
                      " placement="top">
                        <em class="el-icon-info"></em>
                      </el-tooltip>
                      <br />
                    </div>
                    <div>
                      <strong>RPM </strong>
                      <el-input style="width: 100px" size="mini" type="text" v-model="rpm">
                        <i slot="suffix">rpm</i>
                      </el-input>
                      <el-button @click="resetRpm" size="mini" style="
                          margin-left: 10px;
                          padding: 5px;
                          min-height: 25px;
                          max-height: 25px;
                          min-width: 25px;
                          max-width: 25px;
                        " type="default">
                        <i class="el-icon-refresh-left"></i>
                      </el-button>
                    </div>
                  </el-form-item>

                  <el-form-item :label="$t('measurement.domain')">
                    <!-- <el-radio v-model="domain" label="Time">{{
                    $t("measurement.time")
                  }}</el-radio
                  ><br />
                  -->
                    <el-radio v-model="domain" :label="'FFT'">{{
                        $t("measurement.fft")
                    }}</el-radio><br />
                    <el-radio v-model="domain" :label="'Cepstrum'">{{
                        $t("measurement.cepstrum")
                    }}</el-radio><br />
                    <el-radio v-model="domain" :label="'Envelope'">{{
                        $t("measurement.envelope")
                    }}</el-radio><br />
                    <el-radio v-model="domain" :label="'Spectrogram'">{{
                        $t("measurement.spectrogram")
                    }}</el-radio>
                    <br />
                    <el-radio v-model="domain" :label="'PolarAnalyze'">
                      {{ $t("measurement.polarAnalyze") }}
                    </el-radio>
                    <br />
                    <el-radio v-model="domain" :label="'OrbitAnalyze'">
                      {{ $t("measurement.orbitAnalyze") }}
                    </el-radio>
                    <br />
                    <el-radio v-model="domain" :label="'AutoCorrelation'">
                      {{ $t("measurement.autoCorrelation") }}
                    </el-radio>
                  </el-form-item>
                  <el-form-item>
                    <!-- <el-button class="measurementDelete" type="danger" @click="remove()">Delete</el-button> -->
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="20">
                <div v-if="
                  measurement &&
                  measurement.profile &&
                  measurement.profile.sampleSize > 200000
                " class="bigData">
                  <span>{{ $t("measurement.largeFile") }}</span>
                </div>
                <div v-else>
                  <el-row>
                    <el-col>
                      <ChartFFT v-if="domain == 'FFT'" :point="measurement && measurement.point"
                        :rawData="slicedRawdata" 
                          :createdAt="measurement && measurement.createdAt" 
                          :channel="selectValue"
                          :measurementId="measurement && measurement._id"
                        :bearing="
                          measurement &&
                          measurement.point &&
                          measurement.point.bearing
                        " :referenceFrequency="Number(rpm / 60)" :samplingRate="
  measurement ? measurement.calibratedSamplingRate : 100
"></ChartFFT>
                      <ChartCepstrum v-if="domain == 'Cepstrum'" :rawData="slicedRawdata" :samplingRate="
                        measurement ? measurement.calibratedSamplingRate : 100
                      "></ChartCepstrum>
                      <ChartSpectrogram v-if="domain == 'Spectrogram'" :rawData="slicedRawdata" :samplingRate="
                        measurement ? measurement.calibratedSamplingRate : 100
                      "></ChartSpectrogram>
                      <ChartEnvelope v-if="domain == 'Envelope'" :rawData="slicedRawdata" :bearing="
                        measurement &&
                        measurement.point &&
                        measurement.point.bearing
                      " :referenceFrequency="Number(rpm / 60)" :samplingRate="
  measurement ? measurement.calibratedSamplingRate : 100
"></ChartEnvelope>
                      <ChartPolarAnalyze v-if="domain == 'PolarAnalyze'" :rawData="slicedRawdata"
                        :referenceFrequency="Number(rpm / 60)" :samplingRate="
                          measurement ? measurement.calibratedSamplingRate : 100
                        "></ChartPolarAnalyze>
                      <ChartOrbitAnalyze v-if="domain == 'OrbitAnalyze'" :measurement="measurement" :samplingRate="
                        measurement ? measurement.calibratedSamplingRate : 100
                      "></ChartOrbitAnalyze>
                      <ChartAutoCorrelation v-if="domain == 'AutoCorrelation'" :rawData="slicedRawdata"
                        :referenceFrequency="Number(rpm / 60)" :samplingRate="
                          measurement ? measurement.calibratedSamplingRate : 100
                        "></ChartAutoCorrelation>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <br />
      <el-row v-if="
        checkPermission('Readtrend') &&
        this.measurement &&
        this.measurement.point &&
        this.measurement.point._id
      ">
        <el-col :span="24">
          <el-card :shadow="'never'">
            <FormTrend :hideGoTo="true" ref="formTrend" :point="this.measurement.point._id"
              @goMeasurement="goMeasurement" />
          </el-card>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :span="24" v-loading="!loaded" style="padding: 10px">
          <div class="table-title">{{ $t("common.telemetries") }}</div>
          <el-table border :data="
            measurement
              ? measurement.telemetry
              : []
          " class="detail-table">
            <el-table-column :label="$t('common.telemetry')" prop="telemetry" sortable :filters="telemetryFilter"
              :filter-method="filterHandler">
              <template slot-scope="scope">{{
                  telemetryDisplayName(scope.row)
              }}</template>
            </el-table-column>
            <el-table-column prop="value" :label="$t('common.value')">
              <template slot-scope="scope">{{ scope.row.value.toFixed(4) }}
                {{ telemetryUnit(scope.row) }}</template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col v-if="measurement" :span="24" v-loading="!loaded" style="padding: 10px">
          <el-row>
            <div class="table-title">{{ $t("measurement.tags") }}</div>
            <el-tag disable-transitions v-show="!tagsEditing" v-for="item in measurement.tags" :key="item"
              style="margin-left: 10px; margin-top: 5px">{{ tagLocalization(item) }}</el-tag>
            <em v-if="checkPermission('updateMeasurementTags')" class="fas fa-edit edit-tag" size="mini"
              @click="editTags()" v-show="!tagsEditing"></em>
            <el-form v-show="tagsEditing">
              <el-form-item>
                <custom-input-tag v-model="tagsForm"></custom-input-tag>
                <br />
                <el-tag v-for="item in faultsOptions" :key="item.value" :type="item.type" @click="autoFaultTag(item)"
                  effect="dark" style="margin: 1px">
                  {{ $t(`vibration_analyze_report.${item.value}`) }}
                </el-tag>
              </el-form-item>
              <el-form-item>
                <el-button @click="updateTags()">{{
                    $t("measurement.save")
                }}</el-button>
                <el-button @click="tagsEditing = false">{{
                    $t("measurement.cancel")
                }}</el-button>
              </el-form-item>
            </el-form>
            <br />
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="12">
              <div class="table-title">{{ $t("common.details") }}</div>
              <table class="transpose-table" style="width: 100%">
                <tr>
                  <td>{{ $t("measurement.createdAt") }}</td>
                  <td>{{ dateDate(measurement.createdAt) }}</td>
                </tr>
                <tr>
                  <td>{{ $t("common.gateway") }}</td>
                  <td>{{ measurement.gateway }}</td>
                </tr>
                <tr>
                  <td>{{ $t("common.macAddress") }}</td>
                  <td>{{ measurement.macAddress }}</td>
                </tr>
                <tr>
                  <td>{{ $t("measurement.type") }}</td>
                  <td>{{ $t(`common.${measurement.measurementType}`) }}</td>
                </tr>
                <tr>
                  <td>{{ $t("measurement.upload") }}</td>
                  <td>{{ measurement.upload }}</td>
                </tr>
              </table>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12">
              <div class="table-title">
                {{ $t("common.deviceConfiguration") }}
              </div>
              <table class="transpose-table" style="width: 100%">
                <tr>
                  <td>{{ $t("measurement.calibratedSR") }}</td>
                  <td>{{ measurement.calibratedSamplingRate }} Hz</td>
                </tr>
                <tr>
                  <td>{{ $t("measurement.sampleSize") }}</td>
                  <td v-if="measurement && measurement.profile && measurement.profile">
                    {{
                        measurement &&
                        measurement.profile &&
                        measurement.profile.sampleSize
                    }}
                  </td>
                </tr>
                <tr v-if="measurement && measurement.profile && measurement.profile.accelerometerRange">
                  <td>{{ $t("measurement.accRange") }}</td>
                  <td>{{ measurement.profile.accelerometerRange.value }} G</td>
                </tr>
              </table>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="table-title">{{ $t("common.point") }}</div>
              <table class="transpose-table" style="width: 100%">
                <tr v-if="photos.length">
                  <td rowspan="7" style="width:35%">
                    <el-image :src="photos[0].url"></el-image>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("tree.positionOfSensor") }}</td>
                  <td>
                    <el-tag style="margin:0 5px 0 5px" class="ml-2" type="danger" v-for="typ in measurement.point.type"
                      :key="typ">
                    </el-tag>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("tree.machineType") }}</td>
                  <td>{{ measurement.point.machineType }}</td>
                </tr>

                <tr>
                  <td>{{ $t("point.previousFaults") }}</td>
                  <td>
                    <el-tag style="margin:0 5px 0 5px" type="danger" v-for="fault in measurement.point.previousFaults"
                      :key="fault"> {{ fault }}</el-tag>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("tree.driveType") }}</td>
                  <td>{{ measurement.point.driveType }}</td>
                </tr>

                <tr>
                  <td>{{ $t("tree.transmissionType") }}</td>
                  <td>{{ measurement.point.transmissionType }}</td>
                </tr>

                <tr>
                  <td>{{ $t("point.lastMaintenanceDate") }}</td>
                  <td>{{ Date(measurement.point.lastMaintenanceDate) }}</td>
                </tr>

              </table>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <br />

      <br />
      <el-row>
        <el-card :header="$t('measurement.attachments')" :shadow="'never'">
          <el-row>
            <div class="photo-container" v-loading="!photosLoaded">
              <PhotoView class="Photo" v-on:deleted="deletedphoto" v-for="photo in photos" :key="photo.key"
                :photo="photo" :photos="photos.map((x) => x.url)" />
              <span v-if="!photos.length" style="font-size: 14px; font-style: italic">{{
                  $t("measurement.noAttachmentFound")
              }}</span>
            </div>
          </el-row>
        </el-card>
      </el-row>
      <br />
      <el-card v-if="checkPermission('readAlarm') && pointId" :header="$t('dashboard.alarmTransactions')"
        :shadow="'never'">
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination layout="prev, pager, next,sizes" :total="alarmTransactions.data.total"
              :page-sizes="pageSizes" :page-size.sync="query.pageSize" :current-page.sync="query.page"
              @current-change="reloadAlarmTrans" @size-change="reloadAlarmTrans"></el-pagination>
          </el-col>
        </el-row>
        <el-row>
          <el-table v-loading="alarmTransactions.loading" :data="alarmTransactions.data.data" class="border">
            <el-table-column prop="createdAt" :label="$t('measurement.date')">
              <template slot-scope="scope">
                <span>{{ dateDate(scope.row.createdAt) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('dashboard.name')"></el-table-column>
            <el-table-column prop="macAddress" :label="$t('common.macAddress')"></el-table-column>
            <el-table-column prop="point" :label="$t('dashboard.pointPath')" width="250px">
              <template slot-scope="scope">
                <span style="font-size: 12px">
                  <em>{{ pathTran(scope.row.point) }}</em>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="telemetry" :label="$t('common.telemetry')">
              <template slot-scope="scope">
                <span>{{ telemetryDisplayName(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="level" :label="$t('dashboard.alarmLevel')">
              <template slot-scope="scope">
                <span>
                  <em class="color-box" v-bind:style="{
                    'background-color': getColor(scope.row.level.order),
                  }"></em>
                  {{ $t(`dashboard.lastalarms${scope.row.level.name}`) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="score" :label="$t('dashboard.score')">
              <template slot-scope="scope">
                <span>{{ scope.row.score.toFixed(4) }}
                  {{
                      scope.row.telemetry && (scope.row.telemetry.unit || "")
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="score" :label="$t('measurement.options')">
              <template slot-scope="scope">
                <a href="#" @click="load(scope.row.measurementId)">{{
                    $t("measurement.details")
                }}</a>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination layout="prev, pager, next,sizes" :total="alarmTransactions.data.total"
              :page-sizes="pageSizes" :page-size.sync="query.pageSize" :current-page.sync="query.page"
              @current-change="reloadAlarmTrans" @size-change="reloadAlarmTrans"></el-pagination>
          </el-col>
        </el-row>
      </el-card>
      <br />
      <el-dialog :close-on-click-modal="false" width="30%" :title="$t('measurement.CopyLink')"
        :visible.sync="showGeneratedLink">
        <el-row>
          <el-col :span="22">
            <el-input disabled :value="generatedLink" />
          </el-col>
          <el-col :span="2">
            <em @click="copyLinkToClipboard()" style="font-size: 29px; margin-left: 5px; margin-right: 5px"
              class="far fa-clipboard"></em>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog width="30%" :visible.sync="showGenerateLink">
        <span slot="title">
          <span>
            <b> {{ $t("measurement.generate_link_title") }}</b>
            <el-tooltip :content="$t(`measurement.generate_link_info`)" placement="top">
              <em style="margin-left: 10px" class="el-icon-info"></em>
            </el-tooltip>
          </span>
        </span>

        <el-form label-width="45%">
          <el-form-item :label="$t('measurement.allowTrend')" prop="name">
            <el-checkbox v-model="generateLinkPreferences.allowTrend"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('measurement.allowImage')" prop="name">
            <el-checkbox v-model="generateLinkPreferences.allowImage"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('measurement.allowAlarmTransactions')" prop="name">
            <el-checkbox v-model="generateLinkPreferences.allowAlarmTransactions"></el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('measurement.expiresIn')" prop="name">
            <el-select v-model="generateLinkPreferences.expiresIn">
              <el-option v-for="item in expiresInList" :key="item" :label="$t(`expiresIn.${item}`)" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="generateTemporaryLink()">{{
                $t("common.save")
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <div v-else-if="measurement && measurement.device && measurement.device.type == 'DUCKV1'"
      style="display: flex; flex: 1">
      <DuckMeasurementDetails :measurement="measurement"></DuckMeasurementDetails>
    </div>
    
    <el-dialog width="60%" :visible.sync="compareBasketVisible" :title="$t('measurement.compare')" style="text-align:center">
      <CompareMeasurement></CompareMeasurement>
    </el-dialog>
  </div>
</template>

<script>
import FormTrend from "./Form_Trend";
import axios from "axios";
import ChartSpectrogram from "./Chart_Spectrogram";
import ChartFFT from "./Chart_FFT";
import ChartCepstrum from "./Chart_Cepstrum";
import ChartPolarAnalyze from "./Chart_PolarAnalyze";
import ChartOrbitAnalyze from "./Chart_OrbitAnalyze";
import ChartEnvelope from "./Chart_Envelope";
import ChartAutoCorrelation from "./Chart_AutoCorrelation";
import { mapState, mapActions } from "vuex";
import PhotoView from "./Photo_View";
import { treeHelper, colorLib } from "../util";
import dayjs from "dayjs-ext";
import preferences from "../util/preferences";
import measurementService from "../service/measurement";
import prefaultsOptions from "../util/faultTypes";
import DuckMeasurementDetails from "./DuckMeasurementDetails";
import CompareMeasurement from "./CompareMeasurement.vue"

export default {
  name: "measurement-details",
  components: {
    DuckMeasurementDetails,
    CompareMeasurement,
    ChartFFT,
    ChartPolarAnalyze,
    FormTrend,
    PhotoView,
    ChartEnvelope,
    ChartCepstrum,
    ChartOrbitAnalyze,
    ChartSpectrogram,
    ChartAutoCorrelation,
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
      },

      favoriteLoading: false,
      showCompares:false,
      unit: "daily",
      hourCount: 24 * 7,
      pageSizes: [10, 25, 50, 75],
      scoreType: "grmsScores",
      photos: [],
      rpm: 0,
      note: "",
      temperatureAlarm: "",
      domain: "FFT",
      compareBasketVisible: false,
      fftType: "Grms",
      harmonics: 5,
      photosLoaded: false,
      tagsEditing: false,
      tagsForm: [],
      prefaultsOptions: prefaultsOptions,
      rawData: [],
      loaded: false,
      selectList: [],
      coordinateAxises: { "accelerometer_x": "accelerometer_x", "accelerometer_y": "accelerometer_y", "accelerometer_z": "accelerometer_z" },
      selectValue: "",
      measurement: "",
      trends: [],
      alarmsData: {},
      pointId: "",
      measurementId: "",
      measurementReadyUrl: "",
      infoVisibility: false,
      generatedLink: "",
      showGenerateLink: false,
      showGeneratedLink: false,
      generateLinkPreferences: {
        allowTrend: false,
        allowImage: false,
        allowAlarmTransactions: false,
        expiresIn: "4h",
      },
      expiresInList: ["15m", "30m", "1h", "4h", "1d", "7d", "15d", "30d"],
    };
  },
  async created(){
    await this.getTree();
    
  },
  async mounted() {
    this.updateRawdataIndex({
      minIndex: 0,
      minValue: 0,
      maxIndex: 0,
      maxValue: 0,
    });
    
    this.getTelemetry();
    this.measurementId = this.$route.params.id;
    this.load(this.$route.params.id);
  },
  computed: {
    ...mapState("compareSpectrum",["compares"]),
    ...mapState("dashboard", ["alarmTransactions"]),
    ...mapState("admin", ["telemetry"]),
    ...mapState("tree", ["flatTree"]),
    ...mapState("trend", ["trend"]),
    ...mapState("account", ["customer"]),
    ...mapState("measurementsDetails", ["measurements", "rawdataIndex"]),
    favoriteClass() {
      if (this.measurement && this.measurement.favorite) {
        return "el-icon-star-on";
      }
      return "el-icon-star-off";
    },
    faultsOptions() {
      return this.prefaultsOptions.map((x) => {
        return {
          type: "",
          value: x,
        };
      });
    },
    slicedRawdata() {
      if (this.rawdataIndex.minIndex == 0 && this.rawdataIndex.maxIndex == 0) {
        return this.rawData.slice(0, this.rawData.length + 1);
      } else {
        return this.rawData.slice(
          this.rawdataIndex.minIndex,
          this.rawdataIndex.maxIndex
        );
      }
    },
    slicedRawdata2() {
      if (this.rawdataIndex.minIndex == 0 && this.rawdataIndex.maxIndex == 0) {
        return this.rawData2.slice(0, this.rawData.length + 1);
      } else {
        return this.rawData2.slice(
          this.rawdataIndex.minIndex,
          this.rawdataIndex.maxIndex
        );
      }
    },

    defaultTelemetries() {
      if (!this.measurement) return [];
      if (!this.telemetry) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.measurement.telemetry
        .sort((a, b) => (a.telemetry > b.telemetry ? 1 : -1))
        .filter(
          (mt) =>
            ["AUTO_CORRELATION", "CLEARANCE", "CREST", "GRMS", "KURTOSIS", "PEAK", "PEAK_TO_PEAK", "SHAPE_FACTOR", "SKEWNESS", "VRMS", "VRMS_ISO10816"].includes(mt.telemetry)
            && mt.source.includes(this.selectValue)
        );
    },
    telemetryFilter() {
      if (this.measurement.telemetry) {
        let arr = [
          ...new Set(this.measurement.telemetry.map((x) => x.telemetry)),
        ];
        let arrValue = arr.map((x) => {
          return { text: `${x}`, value: `${x}` };
        });
        let arrValueArray = [];
        arrValueArray = arrValue.map((x) => {
          return x;
        });
        return arrValueArray;
      }
      return [];
    },
    sensorFilter() {
      if (this.measurement.telemetry) {
        let arr = [...new Set(this.measurement.telemetry.map((x) => x.sensor))];
        let arrValue = arr.map((x) => {
          return { text: `${x}`, value: `${x}` };
        });
        let arrValueArray = [];
        arrValueArray = arrValue.map((x) => {
          return x;
        });
        return arrValueArray;
      }
      return [];
    },
    treeEmpty() {
      return !this.$store.state.tree.tree.length;
    },
    treeLoading() {
      return this.$store.state.tree.status.loading;
    },

    path: function () {
      console.log("here")
      if (this.measurement && this.measurement.point) {
        return treeHelper.pointIdToPath(this.flatTree,this.measurement.point._id);
      } else return "";
    },
    ...mapState("trend", ["trendCache"]),
  },
  watch: {
    "trendCache.measurementId": function (val) {
      if (val) {
        this.$router.push(`/measurement/${this.trendCache.measurementId}`);
        this.load(this.trendCache.measurementId);
      }
    },
  },
  methods: {
    
    ...mapActions("admin", ["getTelemetry"]),
    ...mapActions("dashboard", ["getAlarmTransactions"]),
    ...mapActions("tree", ["getTree"]),
    ...mapActions("measurementsDetails", [
      "getMeasurement",
      "updateRawdataIndex",
    ]),
    ...mapActions("trend", ["updateTrendCache", "refresh"]),
    showCompareBasket() {
      this.compareBasketVisible = true;
    },
    openCompare(){

    },
    saveNote() {
      var id = this.$route.params.id;
      axios
        .put(`${process.env.VUE_APP_APIURL}/measurement/${id}/note`, {
          note: this.note,
        })
        .then((res) => {
          this.$message.success(
            this.$t(
              `common.${res.data.result == true ? "saved" : "cannotSaved"}`
            )
          );
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
        });
    },
    toggleFavorite() {
      if (this.measurement) {
        let exists =
          this.measurement.favorite != undefined
            ? this.measurement.favorite
            : false;
        let new_value = !exists;

        this.favoriteLoading = true;
        axios
          .put(
            `${process.env.VUE_APP_APIURL}/measurement/${this.measurementId}/favorite`,
            {
              favorite: new_value,
            }
          )
          .then((res) => {
            this.measurement.favorite = new_value;
          })
          .catch((e) => {
            this.$message.error(e.response.data.message);
          })
          .finally(() => {
            this.favoriteLoading = false;
          });
      }
    },
    goMeasurement(measurementId) {
      this.load(measurementId);
    },
    telemetryUnit(row) {
      let t = this.telemetry.data.filter((x) => x.hidden == false)[
        this.telemetry.data
          .filter((x) => x.hidden == false)
          .findIndex((x) => x.name == row.telemetry)
      ];
      if (t) {
        return t.unit;
      } else {
        return row.telemetry.unit;
      }
    },
    telemetryDisplayName(v) {
      let telemetryName = v.telemetry;

      let telemetry = this.telemetry.data
        .filter((x) => x.hidden == false)
        .find((x) => v == x.name);
      if (telemetry && telemetry.displayName) {
        telemetryName = telemetry.displayName;
      }
      telemetryName = this.$t(`duck.${telemetryName}`) + ` (${this.$t("duck." + v.source.trim())})`;
      return telemetryName;
    },

    displayName(data, type) {
      if (data.telemetry != undefined) {
        if (data.sensor == data.telemetry) {
          return data.telemetryData.displayName;
        } else {
          return data[`${type}`];
        }
      }
    },
    propertyDescription(telemetry, properties) {
      if (!properties) return "";
      switch (telemetry) {
        case "VRMS":
        case "GRMS":
          return `Frequency Range: ${properties.frequencyRange[0]} - ${properties.frequencyRange[1]} Hz`;
        default:
          return "";
      }
    },
    handleCommand(command) {
      switch (command) {
        case "download":
          this.download();
          break;
        case "delete":
          this.remove();
          break;
        case "link":
          this.showGenerateLink = true;
          break;
      }
    },
    copyLinkToClipboard() {
      this.$clipboard(this.generatedLink);
      this.$message.info(this.$t("common.copyclipboardsuccess"));
    },
    async generateTemporaryLink() {
      let response = await measurementService.generateLink({
        measurementId: this.measurementId,
        allowTrend: this.generateLinkPreferences.allowTrend,
        allowImage: this.generateLinkPreferences.allowImage,
        allowAlarmTransactions:
          this.generateLinkPreferences.allowAlarmTransactions,
        expiresIn: this.generateLinkPreferences.expiresIn,
      });
      this.showGenerateLink = false;
      this.showGeneratedLink = true;
      this.generatedLink = `${location.href}?token=${response.token}`;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    getColor(order) {
      return colorLib.getAlarmColorByOrder(order);
    },
    
    dateDate(date) {
      return dayjs(date).format(preferences().localization.dateFormat);
    },
    remove() {
      this.$confirm(this.$t("common.AreYouSure"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.warningConfirmText"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          return axios.delete(
            `${process.env.VUE_APP_APIURL}/measurement/${this.$route.params.id}`
          );
        })
        .then(() => {
          if (this.pointId === undefined) {
            this.$router.push("/");
          } else {
            let measurementId = this.$route.params.id;
            let ids = [...this.trend.trend.ids];
            let indexOfMeasurement = ids.indexOf(measurementId);
            if (indexOfMeasurement) {
              ids.splice(indexOfMeasurement, 1);
              if (ids.length) {
                let routingMeasurementId = "";
                if (ids.length >= indexOfMeasurement) {
                  routingMeasurementId = ids[indexOfMeasurement - 1];
                } else {
                  routingMeasurementId = ids[ids.length - 1];
                }

                this.$router.push(`/measurement/${routingMeasurementId}`);
                this.load(routingMeasurementId);

                this.updateTrendCache({
                  ...this.trendCache,
                  measurementId: routingMeasurementId,
                });
                //todo ozan refresh ?
                this.refresh();
              } else {
                this.updateTrendCache("");

                this.$router.push("/");
              }
            } else {
              this.updateTrendCache("");

              this.$router.push("/");
            }
          }
        });
    },

    loadPhotos(id) {
      this.photosLoaded = false;
      axios
        .get(`${process.env.VUE_APP_APIURL}/measurement/${id}/photo`)
        .then((response) => {
          this.photos = response.data;
          this.photosLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          //this.$message.error(this.$t("measurement.errorHasEncountered"));
        })
        .finally(() => {
          this.photosLoaded = true;
        });
    },
    reloadAlarmTrans() {
      if (this.checkPermission("readAlarm") && this.pointId) {
        this.getAlarmTransactions({
          pageSize: this.query.pageSize,
          pageNumber: this.query.page,
          filteredPoints: [this.pointId],
        });
      }
    },
    load(id) {
      this.loaded = false;
      this.getMeasurement(id)
        .then((m) => {
          if (m.point.coordinateXAxis && m.point.coordinateYAxis && m.point.coordinateZAxis) {
            this.coordinateAxises["accelerometer_x"] = `accelerometer_${m.point.coordinateXAxis[0]}`;
            this.coordinateAxises["accelerometer_y"] = `accelerometer_${m.point.coordinateYAxis[0]}`;
            this.coordinateAxises["accelerometer_z"] = `accelerometer_${m.point.coordinateZAxis[0]}`;
          }

          this.selectList =
            m.measurementData.length > 0
              ? m.measurementData
                .map((x) => x.key)
                .sort()
                .map((x) => {
                  return { value: x, label: this.$t(`measurement.${this.coordinateAxises[x]}`) };
                })
              : [];
          this.selectValue =
            this.selectList.length > 0 ? this.selectList[0].value : "";
          if (!!this.trendCache && this.selectValue) {
            let index = this.selectList.findIndex(
              (element) => element.value == this.trendCache.sensor
            );
            if (index < 0) {
              this.selectValue =
                this.selectList[this.selectList.length - 1].value;
            } else {
              this.selectValue = this.selectList[index].value;
            }
          }
          this.measurement = m;
          console.log(m);
          let rpmTelemetry = this.measurement.telemetry.find(
            (x) => x.name == "RPM"
          );
          if (rpmTelemetry) {
            this.rpm = rpmTelemetry.value;
          } else {
            this.rpm = this.measurement.point
              ? this.measurement.point.referenceFrequency * 60 || 0
              : 0;
          }
          this.note = this.measurement.note;
          this.pointId = m.point ? m.point._id : "";
          this.loadPhotos(id);
          this.reloadAlarmTrans();
          this.View();
        })
        .catch((e) => {
          console.log(e);
          if (e.response.status == 404) {
            setTimeout(() => this.$router.push("/"), 2000);
          } else if (e.response.status == 403) {
            this.$message.error(this.$t("admin.accessDenied"));
            //  setTimeout(() => this.$router.push("/login"), 2000);
          }
        });
    },
    deletedphoto(key) {
      const index = this.photos.findIndex((x) => x.key == key);
      if (index > -1) {
        this.photos.splice(index, 1);
      }
    },

    updateTags() {
      var id = this.$route.params.id;
      let preparedtags = this.tagsForm.map((x) => {
        return x.value;
      });
      axios
        .put(`${process.env.VUE_APP_APIURL}/measurement/${id}/tags`, {
          tags: preparedtags,
        })
        .then(() => {
          this.tagsEditing = false;
          this.measurement.tags = preparedtags;
          this.calculatePath();
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
        });
    },
    tagLocalization(item) {
      if (!this.prefaultsOptions.includes(item)) {
        return item;
      } else {
        return this.$t(`vibration_analyze_report.${item}`);
      }
    },
    autoFaultTag(item) {
      if (!this.tagsForm.some((i) => i.value.includes(item.value))) {
        this.tagsForm.push({
          value: item.value,
          label: this.$t(`vibration_analyze_report.${item.value}`),
        });
      }
    },
    editTags() {
      this.tagsForm = this.measurement.tags.map((x) => {
        return { value: x, label: this.tagLocalization(x) };
      });
      this.tagsEditing = true;
    },
    goBack() {
      this.$router.push("/");
    },
    resetRpm() {
      this.rpm = this.measurement.point
        ? this.measurement.point.referenceFrequency * 60 || 0
        : 0;
    },
    download() {
      const url = window.URL.createObjectURL(
        new Blob([JSON.stringify(this.measurement)])
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.measurement.createdAt + ".json"); // or any other extension
      document.body.appendChild(link);
      link.click();
    },
    View() {
      this.loaded = true;
      this.rawData = this.measurement.data[this.selectValue];
    },
  },
};
</script>
<style>
.beta .el-badge__content.is-fixed {
  right: -1px;
}
</style>
<style scoped>
table.transpose-table td {
  padding: 10px;
  margin: 0px;
  border: 1px solid #ebeef5;
}

div.table-title {
  font-size: 20px;
  padding: 10px;
}

table.transpose-table tr:hover {
  background-color: #ebeef5;
}

.color-box {
  width: 10px;
  height: 10px;
  display: inline-block;
}

.fixedheader {
  position: fixed;
  z-index: 999;
  left: 0;
  background: white;
  border-bottom: 2px solid #ececec;
  width: calc(100% - 20px);
  padding: 10px;
  top: 40px;
}

.bigData {
  display: flex;
  min-height: 300px;
}

.bigData span {
  flex: 1;
  align-self: center;
  text-align: center;
}

.photo-container {
  display: flex;
  flex-flow: row wrap;
}

.detail-table.el-table .cell {
  word-break: break-word !important;
}

.el-form--label-top .el-form-item__label {
  margin-bottom: 0px !important;
  padding-bottom: 10px !important;
  line-height: 20px !important;
}

.edit-tag:hover {
  opacity: 1;
}

.edit-tag {
  margin-left: 15px;
  opacity: 0.3;
}
</style>

<style>
#favorite-button:hover {
  transform: scale(1.2);
}

#favorite-button .el-loading-spinner .circular {
  height: 26px;
  width: 26px;
}

#favorite-button .el-loading-spinner {
  margin-top: -15px;
}
</style>

